export default "__VITE_ASSET__QHdkeZcf__"